<template>
	<el-dialog
		:visible.sync="dialogVisible"
		title="证书管理"
		:close-on-click-modal="false"
		:close-on-press-escape="false"
		:modal-append-to-body="false"
		width="800px"
		@close="$emit('refresh')">
		<div class="upload-box">
			<div class="upload-left">
				<p class="upload-title">证书名称</p>
				<el-input placeholder="请输入证书名称" class="cert-name-input" v-model="certName" clearable maxlength="100"></el-input>
				<p class="upload-title mt10">上传证书</p>
				<div class="upload-wrapper" v-loading="uploadLoading">
					<el-upload
						ref="upload"
						drag
						:show-file-list="false"
						:action="action"
						:headers="headers"
						:data="uploadData"
						:file-list="files"
						:before-upload="handleBeforeUpload"
						:on-change="handleChange"
						:on-error="handleError"
						:on-success="handleSuccess">
						<div class="upload-info">
							<div class="upload-image mr8">
								<img :src="uploadimg" />
							</div>
							<div class="upload-tip">
								<div class="message info-text">点击或将文件拖拽到这里上传</div>
							</div>
						</div>
					</el-upload>
				</div>
			</div>
			<div class="upload-right">
				<p class="upload-title">证书列表</p>
				<div class="upload-files">
					<div class="file-item" v-for="(item, index) in files" :key="index">
						<div class="file-name">
							<div class="file-icon1">
								<img src="@/assets/images/zhengshu.png" alt="" />
								{{ item.fileName }}
							</div>
							<div class="file-icon">
								<!-- <i class="el-icon-edit-outline" @click="editFile(item)"></i> -->
								<i class="el-icon-download" @click="downloadFile(item)"></i>
								<i class="el-icon-circle-close" @click="deleteFile(item)"></i>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button @click="dialogVisible = false">返回</el-button>
		</span>
	</el-dialog>
</template>
<script>
// 引入配置文件
const defaultSettings = require("@/settings.js");
// 接口地址
const hostName = defaultSettings.hostName;
import { otherCertList, deletCert } from "@/api/skill";
export default {
	data() {
		return {
			dialogVisible: false,
			uploadimg: require("@/assets/images/upload.png"),
			fileimg: require("@/assets/images/file.png"),
			disabled: false,
			headers: {
				token: `${window.sessionStorage.getItem("token")}`,
			},
			action: `${hostName}skill/courseSkillScore/addFileOssForCert`,
			files: [],
			message: "单次最多上传20张图片（支持扩展名：jpg,jpeg,png）",
			certName: "",
			userId: "",
			fileId: "",
			uploadLoading: false,
		};
	},
	// 修改点 2：新增 computed 属性
	computed: {
		uploadData() {
			return {
				certName: this.certName,
				userId: this.userId,
				fileId: this.fileId,
			};
		},
		// 判断是否有文件正在上传中
		isUploading() {
			// Element UI 的 file 对象有 status 属性：ready, uploading, success, fail
			// 只要有一个文件处于 uploading 状态，就返回 true
			return this.files.some((file) => file.status === "uploading");
		},
	},
	methods: {
		// 显示弹窗
		init(row) {
			this.dialogVisible = true;
			this.certName = "";
			this.userId = row?.userId || "";
			this.fileId = "";
			// 修复后的init方法
			this.$nextTick(() => {
				if (this.$refs.upload) {
					this.$refs.upload.clearFiles();
				}
				this.files = [];
				// 获取证书列表
				this.getCertList();
			});
		},
		// 上传前的钩子
		handleBeforeUpload(file) {
			if (!this.certName.trim()) {
				this.$message.warning("请先输入证书名称");
				return false;
			}
			this.uploadLoading = true;
			return true;
		},
		// 文件状态改变时的钩子
		handleChange(file, fileList) {
			// this.files = fileList;
		},
		// 上传失败的钩子
		handleError(err, file, fileList) {
			this.uploadLoading = false;
		},
		// 上传成功的钩子
		handleSuccess(response, file, fileList) {
			this.uploadLoading = false;
			file.code = response.code;
			file.message = response.msg || "上传成功";
			if (response.code == "0") {
				file.fileUrl = response.data;
				this.certName = "";
				this.getCertList();
			}
		},
		// 获取证书列表
		getCertList() {
			otherCertList({ userId: this.userId }).then((res) => {
				if (res.code == "0") {
					// 处理证书列表
					this.files = res.data;
				}
			});
		},
		// 辅助函数：去除末尾的".00"
		removeTrailingZero(numStr) {
			return numStr.replace(/\.00$/, "");
		},
		formatBytes(size) {
			if (size == 0 || isNaN(size)) return "0 B"; // 处理0或非数字输入

			if (size < 1024) {
				return size + " B";
			} else if (size < 1024 * 1024) {
				const sizeInKB = (size / 1024).toFixed(2);
				return this.removeTrailingZero(sizeInKB) + " KB";
			} else if (size < 1024 * 1024 * 1024) {
				const sizeInMB = (size / (1024 * 1024)).toFixed(2);
				return this.removeTrailingZero(sizeInMB) + " MB";
			} else {
				const sizeInGB = (size / (1024 * 1024 * 1024)).toFixed(2);
				return this.removeTrailingZero(sizeInGB) + " GB";
			}
		},
		editFile(item) {
			this.fileId = item.id;
			this.certName = item.fileName;
		},
		// 删除文件
		deleteFile(item) {
			this.$confirm("是否删除证书?", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			})
				.then(() => {
					deletCert({ id: item.id }).then((res) => {
						if (res.code == "0") {
							this.$message({
								type: "success",
								message: "删除成功!",
							});
							this.fileId = "";
							this.certName = "";
							this.getCertList();
						} else {
							this.$message({
								type: "error",
								message: res.msg,
							});
						}
					});
				})
				.catch(() => {});
		},
		// 下载证书
		downloadFile(row) {
			const fileLink = row.fileAddr;
			// 判断是否为图片格式，图片在新页面打开
			const imageExts = [".jpg", ".jpeg", ".png", ".gif", ".bmp", ".webp", ".svg"];
			const isImage = imageExts.some((ext) => fileLink.toLowerCase().endsWith(ext));
			if (isImage) {
				window.open(fileLink, "_blank");
				return;
			}
			const linkNode = document.createElement("a");
			linkNode.style.display = "none";
			linkNode.href = fileLink;
			linkNode.download = row.fileName;
			document.body.appendChild(linkNode);
			linkNode.click();
			URL.revokeObjectURL(linkNode.href);
			document.body.removeChild(linkNode);
		},
	},
};
</script>

<style lang="scss" scoped>
/deep/ .el-upload-dragger {
	display: flex;
	align-items: center;
	justify-content: space-around;
}

/deep/ .el-dialog__body {
	padding: 10px 20px;
}

.upload-title {
	margin: 0 0 10px;
	font-weight: 600;
	color: #000;
	.tip {
		font-size: 14px;
		color: red;
	}
}

.upload-box {
	display: flex;
	gap: 20px;

	.upload-left {
		flex: 1;
		.upload-wrapper {
			width: 360px;
			.upload-info {
				display: flex;
				align-items: center;

				.upload-image {
					height: 40px;
				}

				.upload-tip {
					text-align: center;
					line-height: 20px;

					.message {
						font-size: 14px;
					}

					.tip {
						font-size: 12px;
						color: rgba(0, 0, 0, 0.4);
					}
				}
			}
		}
	}
	.upload-right {
		flex: 1;
		border-left: 1px solid #f0f0f0;
		padding-left: 20px;
		.upload-files {
			max-height: 400px;
			overflow-y: auto;
		}
		.file-item {
			margin-bottom: 15px;
		}
		.file-name {
			display: flex;
			align-items: center;
			gap: 8px;
			font-size: 13px;
			justify-content: space-between;
		}
		.file-perc {
			margin: 5px 0 0;
			span {
				font-size: 12px;
			}
		}
	}
}

.file-icon1 {
	display: flex;
	align-items: center;
	gap: 10px;
	img {
		width: 30px;
	}
}

.file-icon {
	i {
		cursor: pointer;
		margin-left: 10px;
		font-size: 16px;
	}
}

.error {
	color: red;
	font-size: 12px;
	margin: 0;
}

.mt10 {
	margin-top: 10px;
}

.cert-name-input {
	width: 360px;
}
</style>
